<div class="container-fluid question-divider"  [id]="question?.code">
    <form #form="ngForm" [ngSwitch]="question.answerType">
        <div class="question-body">
            <div class="question-text">{{question.questionText}}</div>
            <div class="question-form">
                <div *ngSwitchCase="QuestionAnswerType.ENTER_DETAILS">
                    <jhi-text-input [(value)]="answerValue" [name]="question.code" [enableChangeButton]="false"
                        [min]="question.caseDataQuestionMeta.minimum" [max]="question.caseDataQuestionMeta.maximum"
                        [disabled]="!form.valid" (action)="answer()" [summaryMode]="summaryMode" [question]="question">
                    </jhi-text-input>
                </div>
                <div *ngSwitchCase="QuestionAnswerType.PICKLIST">
                    <jhi-picklist-input [name]="question.code" [options]="question.picklistQuestionMeta.picklistItems"
                        [enableChangeButton]="false" [(value)]="answerValue" (action)="answer()"
                        [summaryMode]="summaryMode" [question]="question">
                    </jhi-picklist-input>
                </div>
                <div *ngSwitchCase="QuestionAnswerType.YES_NO">
                    <jhi-boolean-input [(value)]="answerValue" [valueText]="question.answerText" [question]="question"
                        [enableChangeButton]="false" (action)="answer()" [summaryMode]="summaryMode"
                        [question]="question">
                    </jhi-boolean-input>
                </div>
            </div>
        </div>
    </form>
</div>
<div class="mt-2" *ngIf="httpErrorMsg">
    <div class="col-12 alert alert-danger">
        {{httpErrorMsg}}
    </div>
</div>